module.exports = __webpack_public_path__ + "img/phone-call.f4604946.svg";